module.exports = __webpack_public_path__ + "99f390b53c5086985cbea9c994237d60.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/team_robert_mobile.jpg
// module id = 675
// module chunks = 0